module.exports = __webpack_public_path__ + "assets/img/f150-ar.svg";